<template>
  <ol class="RunTimelineMonthList">
    <li
      v-for="month in months"
      :key="month.date.toISOString()"
      class="RunTimelineMonthList__item"
      data-testid="runTimelineMonth"
      :class="{'RunTimelineMonthList__item--isPast': isInPast || isPast(endOfMonth(month.date))}"
    >
      <h3
        class="RunTimelineMonthList__itemHeader"
        data-testid="runTimelineMonthHeader"
      >
        {{ format(month.date, ["MMMM", !isThisYear(month.date) ? "yyyy" : null].filter(isTruthy).join(" ")) }}
      </h3>
      <RunTimelineDateList
        :dates="month.dates"
      />
    </li>
  </ol>
</template>

<script lang="ts" setup>
import isTruthy from "@/lib/utils/boolean/isTruthy";
import { endOfMonth, format, isPast, isThisYear } from "date-fns";
import { RunTimelineMonth } from "./RunTimeline.types.ts";
import RunTimelineDateList from "./RunTimelineDateList.vue";

defineProps<{
  months: Array<RunTimelineMonth>,
  isInPast?: boolean,
}>();
</script>

<style lang="scss" scoped>
.RunTimelineMonthList {
  display: grid;
  gap: 2px;
}

.RunTimelineMonthList__item {
  display: grid;
  gap: 2px;
}

.RunTimelineMonthList__itemHeader {
  position: sticky;
  top: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  height: 44px;
  padding: var(--fontSafariOffset) 16px 0;

  outline: solid 2px var(--themeColorNeutral900);
  background-color: var(--themeColorSecondary);
  color: var(--themeColorSecondaryForeground);

  font-size: 14px;
  font-weight: var(--fontWeightMedium);
  text-transform: uppercase;

  .RunTimelineMonthList__item--isPast & {
    background-color: var(--themeColorNeutral200);
    color: var(--themeColorNeutral900);
  }
}
</style>
